import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SidebarState {
    activeLink: string;
    activeIcon: string;
}
const initialState: SidebarState = {
    activeLink: '/book-library',
    activeIcon: 'book-library',
};

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setActiveLink: (state, action: PayloadAction<string>) => {
            state.activeLink = action.payload;
        },
        setActiveIcon: (state, action: PayloadAction<string>) => {
            state.activeIcon = action.payload;
        },
    },
});

export const { setActiveLink, setActiveIcon } = sidebarSlice.actions;
export default sidebarSlice.reducer;
